import http from "../common/http-common";
import authHeader from '../common/auth-header';



class DossierService {





    getAll(params) {
        //console.log(params);
        var headers = authHeader();
        let config = {
            headers,
            params: params,
        }
        //console.log(config)

        return http.get("/dossiers", config);
    }

    updateStatus(id, params) {
        var headers = authHeader();
        // console.log('event.target.name.value : '+event.target.name.value);
        console.log(params);
        console.log(id);
        let config = {
            headers,
            params: params,
        }
        return http.put(`/dossiers/status/${id}`, null, config);
    }

    getAllNew() {
        var headers = authHeader();
        let config = {
            headers,
        }
        //console.log(config)

        return http.get("/dossiers", config);
    }





    get(id) {
        var headers = authHeader();
        let config = {
            headers,
        }
        //console.log(config)
        return http.get(`/dossiers/${id}`, config);
    }

    create(event) {
        var headers = authHeader();
        console.log('event.target.sessionId.value : ' + event.target.sessionId.value);
        var raw = JSON.stringify({
            "sessionId": event.target.sessionId.value,
            "status": event.target.status.value,
            "payMode": event.target.payMode.value,
            "formateur" : event.target.formateur.value,
            "student": {
                "id": event.target.studentId.value,
            }
        });

        //var raw = JSON.stringify(item);

        console.log(raw);
        let config = {
            headers,
        }
        return http.post(`/dossiers`, raw, config);
    }


    update(id, event) {
        var headers = authHeader();
        // console.log('event.target.name.value : '+event.target.name.value);
        //console.log(event);
        var raw = JSON.stringify({
            "status": event.target.status.value,
            "payMode": event.target.payMode.value,
            "formateur" : event.target.formateur.value,
            "price": event.target.price.value,
            "student": {
                "id": event.target.studentId.value,
            },
            "sessionFormation": {
                "id": event.target.sessionId.value,
            },

        });
        console.log(raw);
        let config = {
            headers,
        }
        return http.put(`/dossiers/${id}`, raw, config);
    }


    delete(id) {
        var headers = authHeader();
        let config = {
            headers,
        }
        //console.log(config)
        return http.delete(`/dossiers/${id}`, config);
    }

    deleteAll() {
        return http.delete("/dossiers");
    }


    buildPdfContract(id) {

        var headers = authHeader();
        let config = {
            responseType: 'blob',
            headers,
        }
        //console.log(config)

        return http.get(`/dossiers/pdf/${id}`, config);
    }

    sendPdfContract(id) {

        var headers = authHeader();
        let config = {
            headers,
        }
        //console.log(config)

        return http.get(`/dossiers/pdfsend/${id}`, config);
    }

    buildPdfLivret(id) {

        var headers = authHeader();
        let config = {
            responseType: 'blob',
            headers,
        }
        //console.log(config)

        return http.get(`/dossiers/accueil/${id}`, config);
    }

    sendPdfLivret(id) {

        var headers = authHeader();
        let config = {
            headers,
        }
        //console.log(config)

        return http.get(`/dossiers/accueilsend/${id}`, config);
    }

    buildPdfConvocation(id) {

        var headers = authHeader();
        let config = {
            responseType: 'blob',
            headers,
        }
        //console.log(config)

        return http.get(`/dossiers/convocation/${id}`, config);
    }

    sendPdfConvocation(id) {

        var headers = authHeader();
        let config = {
            headers,
        }
        //console.log(config)

        return http.get(`/dossiers/convocationsend/${id}`, config);
    }

    buildPdfEmargement(id) {

        var headers = authHeader();
        let config = {
            responseType: 'blob',
            headers,
        }
        //console.log(config)

        return http.get(`/dossiers/emargement/${id}`, config);
    }

    sendPdfEmargement(id) {

        var headers = authHeader();
        let config = {
            headers,
        }
        //console.log(config)

        return http.get(`/dossiers/emargementsend/${id}`, config);
    }

    buildPdfAttestation(id) {

        var headers = authHeader();
        let config = {
            responseType: 'blob',
            headers,
        }
        //console.log(config)

        return http.get(`/dossiers/attestation/${id}`, config);
    }

    sendPdfAttestation(id) {

        var headers = authHeader();
        let config = {
            headers,
        }
        //console.log(config)

        return http.get(`/dossiers/attestationsend/${id}`, config);
    }


}

export default new DossierService();
